import { uniqueNamesGenerator, adjectives, animals } from 'unique-names-generator';

const SLUG_MAX = 16;
export const SLUG_RE = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;

export function toSlug(raw) {
  return raw
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SLUG_MAX);
}

export function generateAgentSlug() {
  const raw = uniqueNamesGenerator({ dictionaries: [adjectives, animals], separator: '-', length: 2, style: 'lowerCase' });
  return raw.slice(0, SLUG_MAX);
}

export function shortUuid() {
  const arr = new Uint8Array(3);
  crypto.getRandomValues(arr);
  return Array.from(arr).map(b => b.toString(16).padStart(2, '0')).join('');
}
